import { ProfileModel, profileApi } from '@pukka/api';
import { editOutletComparisonEvent } from '@pukka/clevertap/outletComparison';
import { OutletSelectorV2Modal } from '@pukka/ui-composite';
import { FaChevronDown, FaStoreAlt } from 'react-icons/fa';
import { twMerge } from 'tailwind-merge';
import { useSnapshot } from 'valtio';

import { DerivedState, State } from './comparison.state';

interface OutletSelectorProps {
  readonly disabled?: boolean;
  readonly numberOfOutlets: number;
}

function onSubmit(outlets: Set<ProfileModel.Outlet>) {
  State.onReplace(
    ...[...outlets].map((outlet) => ({
      id: outlet.id ?? -1,
      name: outlet.name ?? '-',
    })),
  );
}

function OutletComparisonSelector({ disabled = false, numberOfOutlets }: OutletSelectorProps) {
  const isActive = numberOfOutlets > 1;
  const { selectedOutletIds } = useSnapshot(DerivedState);
  const { data: profile } = profileApi.useProfile();

  const handleSubmit = (outlets: Set<ProfileModel.Outlet>) => {
    editOutletComparisonEvent(outlets.size, profile);

    onSubmit(outlets);
  };

  return (
    <div data-testid="outlet-comparison-selector" className="relative w-56">
      <OutletSelectorV2Modal onSubmit={handleSubmit} selectedIds={selectedOutletIds} minItems={2} maxItems={10}>
        <button
          type="button"
          disabled={disabled}
          className={twMerge(
            'relative flex min-h-[42px] w-full cursor-pointer items-center rounded-lg border border-neutral-300 p-2.5 text-sm duration-300 ease-in-out hover:bg-neutral-100 focus:ring focus:ring-neutral-200',
            isActive && 'bg-light-blue-50',
            disabled && 'pointer-events-none bg-neutral-300 text-white',
          )}
        >
          <FaStoreAlt className="mr-2" size={20} color={disabled ? 'white' : 'neutral'} />
          <div>{isActive ? `${numberOfOutlets} Outlets` : 'Select Outlet'}</div>
          <FaChevronDown className="absolute right-2 text-neutral-400" size={12} color={disabled ? 'white' : 'black'} />
        </button>
      </OutletSelectorV2Modal>
    </div>
  );
}

export { OutletComparisonSelector, onSubmit as _onSubmit };
